import React from 'react';

// 自定義 Hook
const useCurrentYearMonth = () => {
  const now = new Date();

  // 取得年份的後兩位
  const yearLastTwoDigits = now.getFullYear().toString().slice(-2);

  // 取得月份，並補零至兩位數
  const monthTwoDigits = (now.getMonth() + 1).toString().padStart(2, '0');

  return { yearLastTwoDigits, monthTwoDigits };
};


export default useCurrentYearMonth;
